import {CreateInstance} from './config'
const findIdAPI = CreateInstance('findID')
const resetPwAPI = CreateInstance('resetPW')

const findId = params => {
  return findIdAPI.post('', params)
}

const resetPW = params => {
  return resetPwAPI.post('', params)
}

export {findId, resetPW}
